var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0769 4.61538H8.92308C6.544 4.61538 4.61538 6.544 4.61538 8.92308V22.1908L7.11099 19.7628C9.57829 17.3623 13.4893 17.3017 16.0298 19.6246L22.5747 25.6087C23.98 26.8936 26.1313 26.9013 27.5456 25.6264C28.8484 24.4521 30.7968 24.3545 32.2103 25.3927L35.3846 27.7241V8.92308C35.3846 6.544 33.456 4.61538 31.0769 4.61538ZM8.92308 4C6.20414 4 4 6.20414 4 8.92308V31.0769C4 33.7959 6.20414 36 8.92308 36H31.0769C33.7959 36 36 33.7959 36 31.0769V8.92308C36 6.20414 33.7959 4 31.0769 4H8.92308ZM26.1492 17.5391C27.9619 17.5391 29.4313 16.0697 29.4313 14.2571C29.4313 12.4444 27.9619 10.975 26.1492 10.975C24.3366 10.975 22.8672 12.4444 22.8672 14.2571C22.8672 16.0697 24.3366 17.5391 26.1492 17.5391Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhoto);
export default __webpack_public_path__ + "static/media/no-photo.9be911c0.svg";
export { ForwardRef as ReactComponent };